import { CognitoUserPool } from 'amazon-cognito-identity-js'
import { validateCognitoConfig } from '@brent/shared'

const userPoolId = import.meta.env.VITE_CA_COGNITO_USER_POOL_ID
const clientId = import.meta.env.VITE_CA_COGNITO_CLIENT_ID
const region = import.meta.env.VITE_CA_COGNITO_REGION || 'eu-west-1'
const domain = import.meta.env.VITE_CA_COGNITO_DOMAIN

export const cognitoConfig = validateCognitoConfig({
  userPoolId,
  clientId,
  region,
  domain,
})

export const userPool = new CognitoUserPool({
  UserPoolId: cognitoConfig.userPoolId,
  ClientId: cognitoConfig.clientId,
})
